import NyafazPortalFlowLayout from "../naturals-portal/NyafazPortalFlowLayout";

export default NyafazPortalFlowLayout;
